<div mat-dialog-title class="dialog-title p-3 pr-5 clearfix">
  <h5>
    Select Safety Observation{{ data['multiple'] ? 's' : '' }}
    <span>
      ({{ dataSource.selection.selected.length }})
    </span>
  </h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>

  <form class="form-inline my-2 my-lg-0 float-lg-right" (ngSubmit)="dataSource.getData(true)">
    <button mat-raised-button class="mr-2 mr-lg-3 my-1" type="button" (click)="onFilter()">
      <mat-icon>filter_list</mat-icon> Filter
    </button>

    <input
      class="form-control mr-2 my-1"
      type="search"
      [(ngModel)]="dataSource.search"
      name="search"
      placeholder="Search"
      aria-label="Search"/>

    <button
      mat-raised-button
      color="secondary"
      class="mr-2 mr-lg-3 my-1"
      type="submit"
      matTooltip="Run the current search">
      <mat-icon>search</mat-icon> Search
    </button>

    <button
      mat-raised-button
      type="button"
      class="mr-2 my-1"
      (click)="onClearSelected()">
      Clear Selected
    </button>
  </form>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    matSortActive="date_created"
    matSortDirection="desc"
    matSortDisableClear>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox
          (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)"
          appMarginRight>
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Toggle sorting by the id.">
        #
      </th>
      <td mat-cell *matCellDef="let so">
        {{ so.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="so_description">
      <th mat-header-cell *matHeaderCellDef class="no-padding" [style.width.px]="280">
        Description
      </th>
      <td mat-cell *matCellDef="let so" class="no-padding text-wrap">
        {{ so.so_description }}
      </td>
    </ng-container>

    <ng-container matColumnDef="so_category">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Category
      </th>
      <td mat-cell *matCellDef="let so" class="no-padding text-wrap">
        {{ so.so_category }}
      </td>
    </ng-container>

    <ng-container matColumnDef="so_type">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Type
      </th>
      <td mat-cell *matCellDef="let so" class="no-padding text-wrap">
        {{ so.so_type }}
      </td>
    </ng-container>

    <ng-container matColumnDef="so_status">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Status
      </th>
      <td mat-cell *matCellDef="let so" class="no-padding text-wrap">
        {{ so.so_status }}
      </td>
    </ng-container>

    <ng-container matColumnDef="site">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}
      </th>
      <td mat-cell *matCellDef="let so" class="no-padding text-wrap">
        {{ so.site?.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Toggle sorting by the date reported.">
        Created At
      </th>
      <td mat-cell *matCellDef="let so">
        {{ (so.date_created * 1000) | timezoneConvertMedium }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="dataSource.selection.toggle(row.id)"></tr>
  </table>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-3 py-1">
  <mat-paginator
    class="my-2 ml-1 mr-2"
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>

  <button
    class="my-2 mx-1"
    mat-raised-button
    color="primary"
    type="button"
    (click)="onSaveAndClose()"
    [disabled]="data['required'] && !dataSource.selection.hasValue()">
    Select & Close
  </button>
</mat-dialog-actions>
